(function () {
// TODO: Optimize, accessibility, cleanup
if (customElements.get("samples-cart") === undefined) {
    class SamplesCart extends HTMLElement {
        constructor(){
            super();
            document.addEventListener("cart:updated", this.cartUpdate.bind(this));
            // this.debouncedOnChange = this.debounce((event) => { this.onChange(event) }, 300);
            // this.addEventListener('change', this.debouncedOnChange.bind(this));
            this.addEventListener("click", (event)=>{
                if (event.target.closest("button") && event.target.closest("button").dataset.target) this.showPopup(event);
            });
        }
        showPopup(event) {
            event.preventDefault();
            let targetPopup = document.querySelector(event.target.closest("button").dataset.target);
            if (!targetPopup) return; // To do: error handler
            targetPopup.toggle();
        }
        cartUpdate() {
            this.enableLoading();
            fetch(`?section_id=${this.dataset.sectionId}`).then((response)=>response.text()).then((responseText)=>{
                const targetElement = this.localName;
                const html = new DOMParser().parseFromString(responseText, "text/html");
                const destination = document.querySelector(targetElement);
                const source = html.querySelector(targetElement);
                if (source && destination) destination.innerHTML = source.innerHTML;
                this.disableLoading();
                document.querySelector("#samples-cart-form").scrollIntoView({
                    behavior: "smooth"
                });
            }).catch(()=>{
            // TO DO: Add error handler
            // // if (this.generalErrorElement) this.generalErrorElement.classList.remove('hidden');
            // this.disableLoading();
            });
        }
        enableLoading() {
            this.classList.add("loading");
            document.documentElement.classList.add("loading");
            document.activeElement.blur();
        // if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
        }
        disableLoading() {
            this.classList.remove("loading");
            document.documentElement.classList.remove("loading");
        }
    }
    customElements.define("samples-cart", SamplesCart);
}

})();
